import {
  type BlocksContent,
  BlocksRenderer,
} from "@strapi/blocks-react-renderer";
import clsx from "clsx";

import { Body, Heading } from "@shared/ui/typography";
import { restoreRelativeUrl } from "@shared/utils";

import s from "./text-block.module.scss";

type RichTextType = {
  id: number;
  __component: string;
  texts: BlocksContent | null;
};

export const TextBlock = (props: RichTextType) => {
  const { texts } = props;

  return (
    <div className={s.root}>
      {texts && (
        <BlocksRenderer
          content={texts}
          blocks={{
            paragraph: ({ children }) => (
              <Body className={s.text}>{children}</Body>
            ),
            quote: ({ children }) => (
              <div className={s.blockquote}>{children}</div>
            ),
            link: ({ children, url }) => {
              const cleaned = restoreRelativeUrl(url);
              return (
                <a
                  href={cleaned}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={clsx(s.link, "global-link")}
                >
                  {children}
                </a>
              );
            },
            list: ({ children, format }) => {
              switch (format) {
                case "unordered":
                  return (
                    <Body tag="ul" className={clsx(s.list, s.unordered)}>
                      {children}
                    </Body>
                  );
                case "ordered":
                  return (
                    <Body tag="ol" className={clsx(s.list, s.ordered)}>
                      {children}
                    </Body>
                  );
              }
            },
            heading: ({ children, level }) => (
              <Heading level={level}>{children}</Heading>
            ),
            code: ({ children }) => {
              // @ts-expect-error
              const child = children[0] || {};
              return (
                <div
                  className={s.code}
                  dangerouslySetInnerHTML={{
                    __html: child?.props?.text,
                  }}
                />
              );
            },
          }}
          modifiers={{
            bold: ({ children }) => <strong> {children} </strong>,
          }}
        />
      )}
    </div>
  );
};

TextBlock.displayName = "TextBlock";
